import React from 'react'

const Faq = () => {
    return (
        <>
            <section>
                <div className="login pg-faq">
                    <div className="container">
                        <div className="row">
                            <div className="inn ab-faq-lhs">
                                <div className="form-tit">
                                    <h4>FAQ</h4>
                                    <h1>Frequently asked questions</h1>
                                </div>
                                <div id="accordion">
                                    <div className="card">
                                        <div className="card-header">
                                            <a
                                                className="card-link"
                                                data-toggle="collapse"
                                                href="#collapse1"
                                            >
                                                How Matrimony website works?
                                            </a>
                                        </div>
                                        <div
                                            id="collapse1"
                                            className="collapse show"
                                            data-parent="#accordion"
                                        >
                                            <div className="card-body">
                                                <p>
                                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                                                    sed do eiusmod tempor incididunt ut labore et dolore magna
                                                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-header">
                                            <a
                                                className="collapsed card-link"
                                                data-toggle="collapse"
                                                href="#collapse2"
                                            >
                                                Printing and typesetting industry?
                                            </a>
                                        </div>
                                        <div
                                            id="collapse2"
                                            className="collapse"
                                            data-parent="#accordion"
                                        >
                                            <div className="card-body">
                                                <p>
                                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                                                    sed do eiusmod tempor incididunt ut labore et dolore magna
                                                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-header">
                                            <a
                                                className="collapsed card-link"
                                                data-toggle="collapse"
                                                href="#collapse3"
                                            >
                                                Why do we use it?
                                            </a>
                                        </div>
                                        <div
                                            id="collapse3"
                                            className="collapse"
                                            data-parent="#accordion"
                                        >
                                            <div className="card-body">
                                                <p>
                                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                                                    sed do eiusmod tempor incididunt ut labore et dolore magna
                                                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-header">
                                            <a
                                                className="collapsed card-link"
                                                data-toggle="collapse"
                                                href="#collapse4"
                                            >
                                                There are many variations of passages?
                                            </a>
                                        </div>
                                        <div
                                            id="collapse4"
                                            className="collapse"
                                            data-parent="#accordion"
                                        >
                                            <div className="card-body">
                                                <p>
                                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                                                    sed do eiusmod tempor incididunt ut labore et dolore magna
                                                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-header">
                                            <a
                                                className="collapsed card-link"
                                                data-toggle="collapse"
                                                href="#collapse5"
                                            >
                                                Where can I get some?
                                            </a>
                                        </div>
                                        <div
                                            id="collapse5"
                                            className="collapse"
                                            data-parent="#accordion"
                                        >
                                            <div className="card-body">
                                                <p>
                                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                                                    sed do eiusmod tempor incididunt ut labore et dolore magna
                                                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-header">
                                            <a
                                                className="collapsed card-link"
                                                data-toggle="collapse"
                                                href="#collapse6"
                                            >
                                                Piece of classical Latin literature from 45 BC?
                                            </a>
                                        </div>
                                        <div
                                            id="collapse6"
                                            className="collapse"
                                            data-parent="#accordion"
                                        >
                                            <div className="card-body">
                                                <p>
                                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                                                    sed do eiusmod tempor incididunt ut labore et dolore magna
                                                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    )
}

export default Faq